import {createAction, handleActions} from "redux-actions";

const CHANGE_ANSWER = 'answer/CHANGE_ANSWER';
const LOAD_ANSWER = 'answer/LOAD_ANSWER';
const SET_ERROR = 'answer/SET_ERROR';
const SET_VALIDATE_MODE = 'answer/SET_VALIDATE_MODE';
const SET_VALIDATE_RESULT = 'answer/SET_VALIDATE_RESULT';
const CHANGE_ADDRESS = 'answer/CHANGE_ADDRESS';

export const changeAnswer = createAction(CHANGE_ANSWER, ({ column, answer }) => ({
    column,
    answer
}));

export const loadAnswer = createAction(LOAD_ANSWER, (answers) => answers);

export const setError = createAction(SET_ERROR, val => val);
export const setValidateMode = createAction(SET_VALIDATE_MODE, val => val);
export const setValidateResult = createAction(SET_VALIDATE_RESULT, val => val);
export const changeAddress = createAction(CHANGE_ADDRESS, ({ step, roadAddr, roadAddrDetail, baseAddr, zipNo}) => ({
    step,
    roadAddr,
    roadAddrDetail,
    baseAddr,
    zipNo
}));

const initialState = {
    roadAddr: '',
    roadAddrDetail: '',
    baseAddr: '',
    zpcd: '',
    userNm: '',
    frorAgreeYn: '',
    frorCorpNm: '',
    IS_KOR: '',
    natlGcd: '',
    telNo: '',
    SSN_NO: '',
    empNo: '',
    familyAplyYn: '1',
    email: '',
    intDiviYn: '',
    intYn: '',
    rentYn: '',
    houseCnt: '',
    rentAmt: '',
    rentBusiRegYn: '',
    bizYn: '',
    etcYn: '',
    accNo: '',
    rtnBankGcd: '',
    fileUrl: '',
    IS_ERR: '0',
    dsptNatGcd: '',
    dsptSttDt: '',
    dsptEndDt: '',
    storeCnt: '',
    preBizAmt: '',
    preBizAmt_01: '',
    preBizAmt_02: '',
    preBizAmt_03: '',
    midPrepAmt: '',
    optRentYn: '',
    validateMode: false,
    validateResult: true
};

const answers = handleActions(
    {
        [CHANGE_ANSWER]: (state, action) => ({
            ...state,
            [action.payload.column]: action.payload.answer
        }),
        [LOAD_ANSWER]: (state, action) => ({
            ...state,
            ...action.payload
        }),
        [SET_ERROR]: (state, action) => ({
            ...state,
            IS_ERR: action.payload
        }),
        [SET_VALIDATE_MODE]: (state, action) => ({
            ...state,
            validateMode: action.payload
        }),
        [SET_VALIDATE_RESULT]: (state, action) => ({
            ...state,
            validateResult: action.payload
        }),
        [CHANGE_ADDRESS]: (state, action) => ({
            ...state,
            roadAddr: action.payload.roadAddr,
            roadAddrDetail: action.payload.roadAddrDetail,
            baseAddr: action.payload.baseAddr,
            zpcd: action.payload.zipNo
        }),
    },
    initialState
);

export default answers;
